import { create } from 'zustand';

const useStore = create((set) => ({
    stage: 'intro', // 'intro' | 'wheel' | 'zoomed'
    setStage: (stage) => set({ stage }),

    activeCategory: null,
    setActiveCategory: (category) => set({ activeCategory: category }),

    // For the zoom sequence
    zoomedCategoryId: null,
    setZoomedCategoryId: (id) => set({ zoomedCategoryId: id, stage: id ? 'zoomed' : 'wheel' }),
    // Removed automatic stage switching to 'zoomed' to prevent camera override

    isWheelLocked: false,
    setWheelLocked: (locked) => set({ isWheelLocked: locked }),

    // Scroll Navigation
    targetSection: null, // 'hero' | 'events' | 'sponsors'
    setTargetSection: (section) => set({ targetSection: section }),

    // Initial Loader State
    isLoaded: false,
    setIsLoaded: (loaded) => set({ isLoaded: loaded }),
}));

export default useStore;
